<script lang="ts" setup>
import { computed } from 'vue';

import type { FormSchema } from '@modules/forms/components/VForm/types';
import type {
  PlayersTrackingFormProps,
  PlayersTrackingFormsEmits,
} from '@modules/players/submodules/PlayerProfile/components/PlayersTrackingForm/types';
import type { PlayerTrackingHistoryFormSchema } from '@modules/players/submodules/PlayerProfile/types';
import VButton from '@components/buttons/VButton/VButton.vue';
import VForm from '@modules/forms/components/VForm/VForm.vue';
import { EFormInputTypes } from '@modules/forms/enums';
import { utcDateToLocal } from '@utils/date';

const props = defineProps<PlayersTrackingFormProps>();
const emits = defineEmits<PlayersTrackingFormsEmits>();

const formSchema = computed<FormSchema<PlayerTrackingHistoryFormSchema>>(() => ({
  serial_id: {
    type: EFormInputTypes.NUMBER,
    label: props.serialIdLabel,
    value: props.serialIdValue ? props.serialIdValue : 0,
    required: true,
    useGrouping: false,
    maxFractionDigits: 0,
  },
  anid: {
    type: EFormInputTypes.TEXT,
    label: props.anIdLabel,
    value: props.anIdValue ? props.anIdValue : '',
    required: true,
  },
  date: {
    type: EFormInputTypes.DATE,
    label: props.dateLabel,
    value: props.dateValue ? utcDateToLocal(props.dateValue) : undefined,
    required: true,
  },
}));

function onSubmit(payload: PlayerTrackingHistoryFormSchema): void {
  emits('submit', payload);
}

function onClearError(key: string): void {
  emits('interacted', key);
}
</script>

<template>
  <VForm v-data-qa-auto-id="'PlayersTrackingForm'"
    :schema="formSchema"
    :is-loading="isLoading"
    :custom-errors="errors"
    :submit-btn-label="submitBtnLabel"
    @submit="onSubmit"
    @interacted="onClearError"
  >
    <template #secondaryBtn>
      <VButton
        v-if="backBtnRoute"
        :label="backBtnLabel"
        :to="{ name: backBtnRoute }"
        outlined
      />
    </template>
  </VForm>
</template>
